<script>
export default {
  methods: {
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          this.token = text;
          return text;
        });
    },
    getSubmission() {
      let nuuid = Object.keys(window.drupalSettings.form_builder)[0];
      let submission =
        window.drupalSettings.form_builder[nuuid].submissions[
          this.submissionUuid
        ];
      return submission ? submission : {};
    },
    showAssignmentMessage() {
      this.showSuccessMessage = false;
      if (localStorage.getItem("assignment_message_action") != null) {
        let title = localStorage.getItem("assignment_message_title");
        switch (localStorage.getItem("assignment_message_action")) {
          case "draft":
            this.successMessage = "Draft saved for <i>" + title + "</i>.";
            break;
          case "save":
            this.successMessage = "<i>" + title + "</i> has been saved and sent.";
            break;
        }
        this.showSuccessMessage = true;
      }
    },
    clearAssignmentStorage() {
      if (localStorage.getItem("assignment_message_action")) {
        localStorage.removeItem("assignment_message_action");
        localStorage.removeItem("assignment_message_title");
      }
    },
    isAdministrator() {
      let isAdmin = false;
      if (window.drupalSettings.user.all_available_roles) {
        
        let adminRole = Object.values(window.drupalSettings.user.all_available_roles).filter((role)=>{
          return role == 'administrator';
        });
        console.log(adminRole.length);
        if (adminRole.length) {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    hasRole(role) {
      if (window.drupalSettings.user.all_available_roles) {
        
        let hasRole = Object.values(window.drupalSettings.user.all_available_roles).filter((user_role)=>{
          return user_role == role;
        });
        if (hasRole.length) {
          return true;
        }
      }
      return false;
    }
  },
};
</script>
